import { baseClient } from "@/api";
import { getCachedAccountToken } from "@/contexts/auth/utils";

import type { AxiosInstance } from "axios";

/** Use stateful Axios client with auth. */
export const useApi = (): AxiosInstance => {
  const accessToken = getCachedAccountToken();

  return baseClient(accessToken);
};
